import { DialogWrapper } from "Dialogs/wrapper";
import { useFoldersList } from "@/presentation/hooks/useFoldersList";
import { getPollFolders } from "@/api/poll/get-poll-folders";
import { markGuestFoldersActiveInTree } from "@/utils/editor-folder-mode";

import * as FoldersList from "../components/folders-list";
import { registerComponent } from "@/utils/engine/register-component";
import { Translator } from "@/utils/translate";

registerComponent("move-to-folder-dialog-list", FoldersList);
const pollsTranslator = Translator("polls");

export class ViewModel extends DialogWrapper {
  constructor(params, element) {
    super(params, element);

    element.classList.add("select-poll-folder-dialog");

    const {
      current = "0",
      disabled = [],
      title,
      confirm,
      mode = "default",
      onSelect,
      activateGuestFolders = false,
    } = params;

    this.pending = ko.observable(false);
    this.title = title || pollsTranslator.t("Выберите папку");
    this.onSelect = onSelect;
    this.confirm = confirm || pollsTranslator.t("Выбрать");
    this.mode = mode;

    const { loading, query, list, getSubtree, loaded, originalTree } =
      useFoldersList(getPollFolders);

    // Гостевые папки приходят с бэкенда с inactive: true (доступ по EditorFolderShare
    // не учитывается в EditorFolder), из-за чего useFoldersList вырезал всё гостевое
    // поддерево. Для выбора папки под опрос гостевые папки и их вложенные папки должны
    // быть доступны, а путь до гостевой остаётся заблокированным (#6537, п.13-15).
    // Подписка регистрируется до подписки на автовыбор папки ниже.
    if (activateGuestFolders) {
      loaded.subscribe((v) => {
        if (v) originalTree(markGuestFoldersActiveInTree(originalTree()));
      });
    }

    this.loading = loading;
    this.searchString = query;
    this.flattenedFolders = list;

    this.current = current;
    this.disabled = ko.computed(() => {
      let disabledIds = [];
      disabled.forEach((id) => {
        // Для "Главная страница" (id="0") блокируем только её саму, без подпапок
        if (id === "0" || id === 0) {
          disabledIds.push("0");
        } else {
          disabledIds = [...disabledIds, ...getSubtree(id)];
        }
      });
      return disabledIds;
    });

    this.value = ko.observable(current);

    // Проверяет, является ли выбранное значение допустимым (не disabled)
    this.selectedFolderId = ko.computed(() => {
      const currentValue = this.value();
      const disabledList = this.disabled();

      // Проверяем как строковое, так и числовое значение
      if (disabledList.includes(currentValue) || disabledList.includes(String(currentValue))) {
        return null; // Выбранное значение заблокировано
      }

      return currentValue;
    });

    loaded.subscribe(v => {
      if (v) {
        let items = ko.toJS(list);
        const disabledList = this.disabled();
        let currentItem = items.find(item => String(item.id) === String(current));

        // Проверяем, что текущий элемент не inactive и не заблокирован
        const isCurrentDisabled = disabledList.includes(current) || disabledList.includes(String(current));
        if (currentItem && !currentItem.inactive && !isCurrentDisabled) {
          this.value(currentItem.id);
        } else {
          // Находим первую незаблокированную и не inactive папку
          let item = items.find(i => {
            const isDisabled = disabledList.includes(i.id) || disabledList.includes(String(i.id));
            return !i.inactive && !isDisabled;
          });
          if (item) {
            this.value(item.id);
          }
        }
      }
    })
  }

  onEnter() {
    this.submit();
  }

  submit() {
    this.pending(true);
    this.onSelect(this.value()).then(() => {
      this.pending(false);
      this.hide();
    });
  }
}
